// src/contexts/AppContext.js
import React, { createContext, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";

// Crear el contexto
export const AppContext = createContext();
// Crear el proveedor del contexto
export const AppProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [isLogin, setIsLogin] = useState("");

  const sessionExpired = (text) => {
    Swal.fire({
      icon: "error",
      text: text || "alert.",
      confirmButtonColor: "#B03A2E",
    }).then((result) => {
      localStorage.clear();
      setIsLogin(false);
      navigate("/");
    });
  };

  const closeSession = () => {
    localStorage.clear();
    setUser("");
    setIsLogin(false);
    window.location.reload();
  };

  //Verifico que la session esté activa
  const verifySession = () => {
    const dataLocalStorage = localStorage?.getItem("coopTramites");
    const dataClient = JSON?.parse(dataLocalStorage);
    if (dataClient) {
      setIsLogin(true);
      setUser(dataClient?.owner);
    } else {
      setIsLogin(false);
      setUser("");
    }
  };

  //Ejecuto la verificacion al renderizar la página
  useEffect(() => {
    verifySession();
  }, [isLogin, localStorage]);

  // Definir los valores que se compartirán en el contexto
  const contextValues = {
    user,
    setUser,
    isLogin,
    setIsLogin,
    sessionExpired,
    closeSession,
    verifySession,
  };

  return (
    <AppContext.Provider value={contextValues}>{children}</AppContext.Provider>
  );
};
